// FingerprintJS integration (open-source build only — no paid features).
//
// The module is loaded lazily via dynamic import so the ~30 KB agent never
// enters the initial bundle and, critically, never runs before consent: the
// only caller is `bootstrapIdentity`, which itself runs only on consent
// acceptance. The fingerprint is a *secondary* signal — the server-issued
// cookie is the primary identifier (BUILD_PLAN.md §2.3 / §6 Phase 4).

// Minimal structural type so we don't depend on the package's exported type
// names (which vary across major versions).
interface FpAgent {
  get(): Promise<{ visitorId: string }>;
}

let agentPromise: Promise<FpAgent> | null = null;

async function loadAgent(): Promise<FpAgent> {
  if (!agentPromise) {
    const mod = await import("@fingerprintjs/fingerprintjs");
    agentPromise = mod.default.load();
  }
  return agentPromise;
}

/** Compute the open-source visitor id. Throws if the agent can't load (the
 * caller treats the fingerprint as optional). */
export async function getVisitorId(): Promise<string> {
  const agent = await loadAgent();
  const { visitorId } = await agent.get();
  return visitorId;
}
